import { Breakpoints, FontWeight, Colors } from './assets/styles';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => ({
  '@global': {
    html: {
      boxSizing: 'border-box',
      fontSize: 16,
      margin: 0,
      padding: 0,
    },
    '*, *:before, *:after': {
      boxSizing: 'inherit',
    },
    body: {
      fontFamily: ['Museo Sans', 'sans-serif'].join(','),
      margin: 0,
      backgroundColor:'#fafafa !important'
    },
    ul: {
      listStyleType: 'none',
      padding: 0,
    },
    button: {
      fontFamily: 'inherit',
      boxShadow: 'none',
      border: 'none',
      padding: 0,
      overflow: 'visible',
      background: 'transparent',
      cursor: 'pointer',
      outline: 'none',
      textDecoration: 'none',
    },
    a: {
      fontSize: 15,
      fontWeight: FontWeight.Light,
      color: Colors.Blue1,
      textDecoration: 'none',
    },
    // Media queries for html font-size
    // [theme.breakpoints.down(Breakpoints.MD)]: {
    //   html: {
    //     fontSize: 15,
    //   },
    // },
    // [theme.breakpoints.down(Breakpoints.SM)]: {
    //   html: {
    //     fontSize: 14,
    //   },
    // },
    // [theme.breakpoints.down(Breakpoints.XS)]: {
    //   html: {
    //     fontSize: 13,
    //   },
    // },
  },
}));

  export default useStyles;
